import React from 'react';
import { useTranslation } from 'react-i18next';

const ThreatComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.threat_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Threat Type</th>
            <td>{t(`threat.${report.threat_type.toLowerCase()}`)}</td>
          </tr>
          {/* <div className="my-2">
            <h2 className="inline-block w-full">Target</h2>
            <p className="px-8 pt-12">{report.target}</p>
          </div> */}
        </tbody>
      </table>
    </div>
  );
};

export default ThreatComponent;
